import * as React from "react";
import { Box, Typography, Container, Button, TextField } from "@mui/material";

const BRAND = "#f05d32";

export default function SubscriptionSection(props) {
  const { component } = props;

  return (
    <Box
      sx={{
        overflow: "hidden",
        background:
          "linear-gradient(135deg, #f7c48a 0%, #f4b571 45%, #ef9f55 100%)",
      }}
    >
      <Container maxWidth="lg" sx={{ px: 2 }}>
        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            component
              .getApp()
              .newsletterSubscribe(
                component.getData("default.subscribe.email"),
              );

            component.setData({ "default.subscribe.email": "" });
          }}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: { xs: 3, md: 5 },
            py: { xs: 3.5, md: 4.5 },
          }}
        >
          <Box
            sx={{
              flex: 1,
              width: "100%",
              maxWidth: 640,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Typography
              component="h2"
              sx={{
                mb: 1,
                fontSize: { xs: 24, sm: 28, md: 34 },
                fontWeight: 700,
                lineHeight: 1.15,
                color: "#1a1a1a",
                letterSpacing: "-0.02em",
              }}
            >
              {component.ucfirst("subscribe-title")}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 14, md: 16 },
                mb: { xs: 2.5, md: 3.5 },
                color: "rgba(0,0,0,0.65)",
                maxWidth: 480,
                mx: { xs: "auto", md: 0 },
                lineHeight: 1.5,
              }}
            >
              {component.ucfirst("subscribe-info")}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "stretch", sm: "center" },
                justifyContent: { xs: "center", md: "flex-start" },
                gap: 1.25,
                maxWidth: { xs: 360, sm: "none" },
                mx: { xs: "auto", md: 0 },
              }}
            >
              <TextField
                variant="outlined"
                fullWidth
                id="email"
                type="email"
                placeholder={component.ucfirst("email-holder")}
                onChange={(e) =>
                  component.setData({
                    "default.subscribe.email": e.target.value,
                  })
                }
                value={component.getData("default.subscribe.email", "")}
                sx={{
                  maxWidth: { sm: 340 },
                  bgcolor: "#fff",
                  borderRadius: "50px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                  "& .MuiOutlinedInput-input": {
                    py: 1.75,
                    px: 2.5,
                    fontSize: 15,
                  },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "50px",
                    "& fieldset": {
                      border: "1px solid transparent",
                      borderRadius: "50px",
                    },
                    "&:hover fieldset": {
                      borderColor: "rgba(0,0,0,0.12)",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: BRAND,
                      borderWidth: 1.5,
                    },
                  },
                }}
              />
              <Button
                type="submit"
                sx={{
                  textTransform: "none",
                  fontSize: 15,
                  fontWeight: 600,
                  borderRadius: "50px",
                  backgroundColor: "#111",
                  px: 3,
                  height: 54,
                  flexShrink: 0,
                  color: "#fff",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                  transition: "background 0.2s ease, transform 0.2s ease",
                  "& i": {
                    mr: 1,
                  },
                  "&:hover": {
                    bgcolor: BRAND,
                    transform: "translateY(-1px)",
                  },
                }}
              >
                <i className="fa-light fa-envelope" />
                {component.ucfirst("subscribe-btn")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
